import generateValidation from 'forms-utils-lib/formField/lib/generateValidation';
import defaultDependentContactFormField from 'forms-utils-lib/formField/constants/defaultDependentContactFormField';
import defaultDependentCompanyFormField from 'forms-utils-lib/formField/constants/defaultDependentCompanyFormField';
import defaultDependentTicketFormField from 'forms-utils-lib/formField/constants/defaultDependentTicketFormField';
import { FormFieldPropertyObjectTypesIds } from 'forms-utils-lib/constants/PropertyObjectTypes';
import getPropertyObjectTypeValue from './getPropertyObjectTypeValue';
import isContactField from './isContactField';
import isCompanyField from './isCompanyField';
import isTicketField from './isTicketField';
const createDependentFormField = args => {
  const validation = generateValidation(args.name);
  const propertyObjectType = getPropertyObjectTypeValue(args.objectTypeId || FormFieldPropertyObjectTypesIds.CONTACT);
  const overrides = Object.assign({
    validation
  }, args, {
    propertyObjectType
  });
  if (isContactField(args)) {
    return Object.assign({}, defaultDependentContactFormField, overrides);
  }
  if (isCompanyField(args)) {
    return Object.assign({}, defaultDependentCompanyFormField, overrides);
  }
  if (isTicketField(args)) {
    return Object.assign({}, defaultDependentTicketFormField, overrides);
  }
  return Object.assign({}, defaultDependentContactFormField, overrides);
};
export default createDependentFormField;